import { UploadRequestOption } from "rc-upload/lib/interface";
import { memo, ReactElement, useCallback, useMemo } from "react";
import UI_MemoizedModuleDocuments from "../../../../UI_ITO/UI_ITOModuleDocuments/UI_MemoizedModuleDocuments";
import { DocumentInfo } from "../../../../UI_ITO/indexUI";
import { IDocCardProps } from "../../../../interfaces/props/IDocCardProps";
import DocButtons from "./DocButtons/DocButtons";

function DocCard(props: IDocCardProps): ReactElement {
  const {
    item,
    index,
    error,
    isUploadingDocument,
    uploadDocumentCallback,
    deleteDocumentCallback = null,
    downloadDocumentCallback,
    Tag = null,
    applicationBankStatus,
    icon,
    isActive = false,
  } = props;

  const { document, name } = item;
  const textName = document ? document.name : "";
  const errorMessage = error || "";

  const textDownCard = useMemo(
    () => (errorMessage ? errorMessage : textName),
    [errorMessage, textName],
  );
  const isDocBolean = useMemo(
    () => (document === null || error ? false : true),
    [document, error],
  );
  const isDocSigned = !!document?.sign_file?.length;

  const onClickDownload = useCallback(() => {
    if (item?.document?.name && item?.document?.id)
      downloadDocumentCallback({
        name: item.document.name,
        document_id: item.document.id,
      });
  }, [downloadDocumentCallback, item?.document?.id, item?.document?.name]);

  const deleteDocument = useCallback(() => {
    if (deleteDocumentCallback) {
      deleteDocumentCallback({
        id: item.id,
        document_id: item?.document?.id,
      });
    }
  }, [deleteDocumentCallback, item?.document?.id, item.id]);

  const beforeUpload = useCallback(
    (options: UploadRequestOption) => {
      uploadDocumentCallback(options, index, item.document); // !!!!!
    },
    [index, uploadDocumentCallback],
  );

  return (
    <UI_MemoizedModuleDocuments
      title={name}
      titleDown={
        <DocumentInfo
          onClick={onClickDownload}
          text={textDownCard}
          upload={isDocBolean}
          isActive={isActive}
        />
      }
      icon={
        <DocButtons
          beforeUpload={beforeUpload}
          isUploadingDocument={isUploadingDocument}
          isDocBolean={isDocBolean}
          isDocSigned={isDocSigned}
          deleteDocument={deleteDocument}
          applicationBankStatus={applicationBankStatus}
          Tag={Tag}
          icon={icon}
          disabled={isActive}
        />
      }
    />
  );
}

export default memo(DocCard);
